function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { OrgData } from "src/data/org/OrgData";
import LoadableObjContainer from "nood-comp/src/comp/ui/containers/LoadableObjContainer";
import Div from "nood-comp/src/comp/ui/containers/Div";
import Space from "nood-comp/src/comp/ui/space/Space";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import ObjectViewer from "nood-comp/src/comp/object-viewer/ObjectViewer";
export default function OrgView(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    org = _useState2[0],
    set_org = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    set_errors = _useState4[1];
  var id = useURLParam('id');
  useEffect(function () {
    if (id) {
      new OrgData().one(id, set_org, set_errors, function (resp) {
        var _document$title, _resp$data;
        document.title = (_document$title = document.title) === null || _document$title === void 0 ? void 0 : _document$title.concat(" / ".concat((_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.display_name));
      });
    }
  }, [id]);
  useEffect(function () {
    if (org) {}
  }, [org]);
  return /*#__PURE__*/React.createElement(LoadableObjContainer, {
    obj: org
  }, org && /*#__PURE__*/React.createElement(Div, {
    pad: 30
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-XL"
  }, org.display_name), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, org.username), " \xB7", /*#__PURE__*/React.createElement(Space, null), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, org.email_address), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(ObjectViewer, {
    obj: org
  })));
}
OrgView.propTypes = {
  // proptypes
};
OrgView.defaultProps = {
  // default propTypes
};